import React from 'react'

const TransferServices = () => {
  return (
    <div>TransferServices</div>
  )
}

export default TransferServices